import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { IdNameModel } from '../model/IdNameModel';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { DataResponseModel } from '../model/ResponseModel';
// {
//     "status": "success",
//     "data": {
//         "projects": [
//             {
//                 "id": 1,
//                 "name": "040",
//                 "description": "300",
//                 "isOverhead": false
//             },
//             {
//                 "id": 2,
//                 "name": "2025",
//                 "description": "Overhead",
//                 "isOverhead": true
//             },
//             {
//                 "id": 3,
//                 "name": "2026",
//                 "description": "300",
//                 "isOverhead": true
//             },
//             {
//                 "id": 4,
//                 "name": "2024",
//                 "description": "2024",
//                 "isOverhead": false
//             }
//         ],
//         "paycodes": [
//             {
//                 "id": 2,
//                 "name": "1st Shift",
//                 "description": "regular pay code for shift 1st Shift",
//                 "isDayOff": false,
//                 "type": "Reg",
//                 "shift": {
//                     "id": 1,
//                     "name": "1st Shift"
//                 }
//             },
//             {
//                 "id": 3,
//                 "name": "Default Pay Code",
//                 "description": "",
//                 "isDayOff": false,
//                 "type": "Reg",
//                 "shift": null
//             },
//             {
//                 "id": 4,
//                 "name": "Holiday",
//                 "description": "Pay code for holidays",
//                 "isDayOff": true,
//                 "type": "Reg",
//                 "shift": null
//             },
//             {
//                 "id": 7,
//                 "name": "Jury Duty",
//                 "description": "Pay code for jury duty",
//                 "isDayOff": true,
//                 "type": "Reg",
//                 "shift": null
//             },
//             {
//                 "id": 1,
//                 "name": "Sick",
//                 "description": "For Sick",
//                 "isDayOff": true,
//                 "type": "Reg",
//                 "shift": null
//             },
//             {
//                 "id": 6,
//                 "name": "Unpaid",
//                 "description": "Pay code for unpaid leave",
//                 "isDayOff": true,
//                 "type": "Reg",
//                 "shift": null
//             },
//             {
//                 "id": 5,
//                 "name": "Vacation",
//                 "description": "Pay code for vacations",
//                 "isDayOff": true,
//                 "type": "Reg",
//                 "shift": null
//             }
//         ],
//         "companies": [
//             {
//                 "id": 1,
//                 "name": "HPSI"
//             },
//             {
//                 "id": 2,
//                 "name": "APSI"
//             }
//         ],
//         "departments": [
//             {
//                 "id": 1,
//                 "name": "HPSI",
//                 "code": 1
//             },
//             {
//                 "id": 2,
//                 "name": "Test",
//                 "code": 663
//             },
//             {
//                 "id": 3,
//                 "name": "Test",
//                 "code": 656
//             },
//             {
//                 "id": 4,
//                 "name": "Test",
//                 "code": 649
//             },
//             {
//                 "id": 5,
//                 "name": "Test",
//                 "code": 420
//             },
//             {
//                 "id": 6,
//                 "name": "Test",
//                 "code": 630
//             },
//             {
//                 "id": 7,
//                 "name": "Test",
//                 "code": 650
//             },
//             {
//                 "id": 8,
//                 "name": "Test",
//                 "code": 904
//             }
//         ],
//         "workerTypes": [
//             {
//                 "id": 1,
//                 "name": "Painter A"
//             },
//             {
//                 "id": 2,
//                 "name": "Supervisor"
//             },
//             {
//                 "id": 3,
//                 "name": "Supervisor 1"
//             },
//             {
//                 "id": 4,
//                 "name": "1"
//             },
//             {
//                 "id": 5,
//                 "name": "2"
//             },
//             {
//                 "id": 6,
//                 "name": "3"
//             },
//             {
//                 "id": 7,
//                 "name": "4"
//             },
//             {
//                 "id": 8,
//                 "name": "5"
//             }
//         ],
//         "shifts": [
//             {
//                 "id": 1,
//                 "name": "1st Shift"
//             },
//             {
//                 "id": 2,
//                 "name": "2nd Shift"
//             }
//         ],
//         "payGroups": [
//             {
//                 "id": 1,
//                 "name": "Salary Over 50"
//             },
//             {
//                 "id": 2,
//                 "name": "Salary Over 40"
//             },
//             {
//                 "id": 3,
//                 "name": "Salary"
//             },
//             {
//                 "id": 4,
//                 "name": "Hourly"
//             }
//         ]
//     }
// }
export interface ProjectFilterValue {
  id: number;
  name: string;
  description: string;
  isOverhead: boolean;
}

export interface PayCodeFilterValue {
  id: number;
  name: string;
  description: string;
  isDayOff: boolean;
  type: string;
  shift: IdNameModel | null;
}

export interface CompanyFilterValue {
  id: number;
  name: string;
  isSubtractor: boolean;
}

export interface DepartmentFilterValue {
  id: number;
  name: string;
  code: number;
}

export interface WorkerTypeFilterValue {
  id: number;
  name: string;
}

export interface ShiftFilterValue {
  id: number;
  name: string;
}

export interface PayGroupFilterValue {
  id: number;
  name: string;
  isOvertimeEligible: boolean;
  overtimeThresholdHours: number;
}

export interface FilterValuesResponse {
  projects: ProjectFilterValue[];
  paycodes: PayCodeFilterValue[];
  companies: CompanyFilterValue[];
  departments: DepartmentFilterValue[];
  workerTypes: WorkerTypeFilterValue[];
  shifts: ShiftFilterValue[];
  payGroups: PayGroupFilterValue[];
}

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  baseUrl = environment.apiBaseUrl + '/api/users/filter-values';
  private http = inject(HttpClient);
  filterValues: null | FilterValuesResponse = null;

  getFilterValues(): Observable<DataResponseModel<FilterValuesResponse>> {
    return this.http.get<DataResponseModel<FilterValuesResponse>>(this.baseUrl).pipe(
      tap((response) => {
        if (response.status === 'success') {
          this.filterValues = response.data;
        }
      }),
    );
  }
}
